<template>
  <div class="w-m-content" >
    <div class="w-m-header">
      <p class="font-14 font-bold no-margin" style="color: #293e52">
        Importação de lotes e bens via upload de arquivo
      </p>
      <div class="m-t-xs font-13 text-grey-7" style="color: #748396; padding-right: 20px; line-height: 1">
        Utilize planilhas excel, arquivos json, entre outros.
      </div>
    </div>
    <div class="w-m-body e-input-modern flex items-center center justify-center">
      <div class="text-center">
        <div class="text-center text-3x m-b"><u-icon color="grey" name="comment-alt-smile" type="fa"/></div>
        <strong>Importação não parametrizada.</strong> Consulte seu gerente de contas SL para habilitar esta opcão.
      </div>
    </div>
    <div class="w-m-footer text-right">
      <u-btn type="submit" label="Ok" color="grey" @click="$uloc.window.close($root.wid)" class="b-radius-3px" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportacaoArquivo'
}
</script>

<style scoped>

</style>
